import React from 'react';
import { fetchToken, LayerCollection, useLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

const PreviewLayer = () => {
  const layers = useLayers();

  const previewLayerName = useAppState((state) => state.previewLayer);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  if (!previewLayerName || layers.isLoading) return null;
  if (selectedTopicLayers.includes(previewLayerName)) return null;

  const previewLayer = layers.data?.[previewLayerName];
  if (!previewLayer) return null;

  const layerInfo: Record<string, any> = {
    [previewLayerName]: {
      isPublic: previewLayer.isPublic ?? true,
    },
  };

  const previewLayerCollection = [layers.data?.[previewLayerName]].map((layer) => {
    return {
      url: layer.url,
      type: layer.type,
      projection: 'EPSG:2056',
      properties: layer.properties,
      id: layer.id,
    };
  });

  return (
    <LayerCollection
      layers={previewLayerCollection}
      zIndices={[previewLayerName]}
      layerInfo={layerInfo}
      startIndex={2000}
      retrieveToken={fetchToken}
    />
  );
};

export default PreviewLayer;
